import ExcelJS from "exceljs";
import { formatDateTime, formattedDate, getCurrentDateTime, getCurrentDateTime1 } from "../../../../Common/helper/helpar";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";
import jsPDF from "jspdf"; // Add this for PDF export
import autoTable from "jspdf-autotable";
export const TippingFeeExport = ({ fromDate, toDate }) => {
    const { tippingFeeReportData, } = TippingFeeCalculationStore()

    const formatTwo = (val) => Number(val || 0).toFixed(2);
    const currentDate = getCurrentDateTime();
    const currentDateTime = getCurrentDateTime1();
    const totalHMSWTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Tonnage) || 0), 0);
    const totalGHMCTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Tonnage) || 0), 0);
    const totalTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.total_Tonnage) || 0), 0);
    const totalHMSWTipping = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Tipping) || 0), 0);
    const totalGHMCTipping = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Tipping) || 0), 0);
    const totalAmount = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.total_Amount) || 0), 0);
    const downloadAsExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Tipping Fee Calculation Report");

        // Define styles
        const boldFont = { bold: true };

        // Get current date and time
        const currentDate = new Date();
        const formattedDateStr = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Tipping Fee Calculation Report Generated on: ${formattedDateStr}, ${formattedTime}`;
        const headerText = `Tipping Fee Calculation Report as on (${formattedDate(fromDate)} to ${formattedDate(toDate)})`;
        // Add the downloadDateTime to the worksheet
        worksheet.addRow(["", "", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 8);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        // Add report title
        worksheet.addRow(["", "", headerText, ""]);
        worksheet.mergeCells(2, 2, 2, 8);
        worksheet.getCell(2, 2).value = headerText;
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        // Define table headers
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "Date",
            "HMSW Tonnage",
            "GHMC Tonnage",
            "Total Tonnage",
            "HMSW Tipping Fee",
            "GHMC Tipping Fee",
            "Total Amount",
        ]);

        tableHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "center", wrapText: true, vertical: "middle" };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" },
                bgColor: { argb: "FFFFFFFF" },
            };
        });

        // Add data rows
        tippingFeeReportData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                formattedDate(item.transactionDate),
                formatTwo(item.himsW_Tonnage),
                formatTwo(item.ghmC_Tonnage),
                formatTwo(item.total_Tonnage),
                formatTwo(item.himsW_Tipping),
                formatTwo(item.ghmC_Tipping),
                formatTwo(item.total_Amount),
            ]).eachCell({ includeEmpty: true }, (cell) => {
                cell.alignment = { horizontal: "center" };
            });
        });

        // Add total row
        worksheet.addRow([
            "",
            "Total",
             formatTwo(totalHMSWTonnage),
            formatTwo(totalGHMCTonnage),
            formatTwo(totalTonnage),
            formatTwo(totalHMSWTipping),
            formatTwo(totalGHMCTipping),
            formatTwo(totalAmount),
        ]).eachCell({ includeEmpty: true }, (cell) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
        });

        // Set column widths dynamically
        worksheet.columns = [
            { width: 10 },
            { width: 25 },
            { width: 25 },
            { width: 25 },
            { width: 25 },
            { width: 25 },
            { width: 25 },
            { width: 25 },
        ];

        // Save the workbook to a file
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "TippingFeeCalculationReport.xlsx";
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };

    const downloadAsPDF = () => {
        const doc = new jsPDF();
        const tableColumn = ["S.No", "Date", "HMSW Tonnage", "GHMC Tonnage", "Total Tonnage", "HMSW Tipping Fee", "GHMC Tipping Fee", "Total Amount"];
        const tableRows = [];
        const headerText = `Tipping Fee Calculation Report as on (${formattedDate(fromDate)} to ${formattedDate(toDate)})`;
        const topHeaderText = `Tipping Fee Calculation Report is generated on (${currentDateTime})`;
        const styledText = (text, x, y, size, options = {}) => {
            const originalSize = doc.getFontSize();
            doc.setFontSize(size);
            doc.text(text, x, y, options);
            doc.setFontSize(originalSize); // Reverts back automatically
        };
        tippingFeeReportData.forEach((item, index) => {
            const rowData = [
                index + 1,
                formattedDate(item.transactionDate),
                formatTwo(item.himsW_Tonnage),
                formatTwo(item.ghmC_Tonnage),
                formatTwo(item.total_Tonnage),
                formatTwo(item.himsW_Tipping),
                formatTwo(item.ghmC_Tipping),
                formatTwo(item.total_Amount),
            ];
            tableRows.push(rowData);
        });

        // Add total row
        tableRows.push([
            "",
            "Total",
            formatTwo(totalHMSWTonnage),
            formatTwo(totalGHMCTonnage),
            formatTwo(totalTonnage),
            formatTwo(totalHMSWTipping),
            formatTwo(totalGHMCTipping),
            formatTwo(totalAmount),
        ]);

        // Add title and date (centered)
        const pageWidth = doc.internal.pageSize.width;
        const titleX = pageWidth / 2;
        const dateX = pageWidth / 2;
        // doc.text(downloadDateTime, dateX, 15, { align: "center" });
        styledText(topHeaderText, titleX, 15, 12, { align: "center" });
        styledText(headerText, titleX, 24, 14, { align: "center" });

        // Use autoTable with centered text
        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 35,
            theme: "striped",
            headStyles: { halign: "center" }, // Center header text
            styles: { halign: "center" }, // Center all table content
        });

        // Save the PDF
        doc.save("TippingFeeCalculationReport.pdf");
    };

    return (
        <>
            <button className="btn btn-excel" onClick={downloadAsPDF}>
                <i class="fa-solid fa-file-excel me-1 icon-container"></i> PDF
            </button>
            <button className="btn btn-excel" onClick={downloadAsExcel}>
                <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
            </button>
        </>
    );
};
